import {Component, OnInit} from '@angular/core';
import {AppBaseComponent} from "@utils";
import {ControlContainer, FormBuilder} from "@angular/forms";
import { MessageService} from "@services";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-visit-info',
  templateUrl: './visit-info.component.html',
  styleUrls: ['./visit-info.component.scss']
})
export class VisitInfoComponent extends AppBaseComponent implements OnInit {

  public infoVisitForm;

  requiereVisita: boolean = false;

  datalocalURL: string;

  urlImageView: string ='https://cdn-icons-png.flaticon.com/512/2889/2889358.png';
  urlDowmloadpdf: string ='https://cdn-icons-png.flaticon.com/512/337/337946.png';

  documentActual;
  constructor(public fb: FormBuilder,
              private controlContainer: ControlContainer,
              private popupService: MessageService,
              private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.infoVisitForm = this.controlContainer.control;
    this.infoVisitForm = this.infoVisitForm.controls['visitInfoForm'];
    console.log("estoy visitInfoFOrm", this.infoVisitForm.value)
    this.requiereVisita = this.infoVisitForm.get('requireVisit').value;
  }

  changeRequiereVisita(): void {
    this.requiereVisita = !this.requiereVisita ;
    this.infoVisitForm.get('requireVisit').setValue(this.requiereVisita);
  }

  public checkSelectedFile(event: any): void {
    let archivos = event.target.files;
    if (archivos.length > 1) {
      this.popupService.errorAlert('Solo puedes cargar un archivo', 3000);
      event.target.value = '';
    }

    if (archivos.length == 1 && archivos[0].type != 'application/pdf') {
      event.target.value = '';
      this.popupService.errorAlert(
        'Formato no valido, solo se admiten documentos en formato PDF',
        3000
      );
    }

    const file = event.target.files[0] || null;
    this.infoVisitForm.patchValue({
      actVisitFile: file,
    });

    console.log(" el archivo que subí es este:", event.target)
    this.documentActual = event.target.files[0];

    this.extraerBase64(event.target.files[0]).then(archivo => {
      this.documentActual = archivo;
      this.documentActual = this.documentActual.base;
    })
  }

  visorPdf() {

    //Descargar archivo
    try {
      this.popupService.infoAlert(
        'Cargando documento...',
        4000);

      let fileObtenido = null;

      fileObtenido = this.documentActual;
      //corta la cdena del base64
      fileObtenido = fileObtenido.slice(28,-1)
      const byteArray = new Uint8Array(atob(fileObtenido).split('').map((char) => char.charCodeAt(0)));
      const file = new Blob([byteArray], {type: 'application/pdf'});
      this.datalocalURL = URL.createObjectURL(file);
      (<HTMLIFrameElement>document.getElementById("iFrameVisit")).src = this.datalocalURL;
    } catch (e) {
      this.popupService.errorAlert(
        'Ocurrió un error al cargar el documento.',
        4000);
      console.log("este es el error", e)
    }

  }

  viewInOtherPagePdf() {

    try {
      this.popupService.infoAlert(
        'Cargando documento...',
        4000);
      //Descargar archivo
      let fileObtenido = null;

      //console.log("valor documento", resp)
      fileObtenido = this.documentActual;
      //corta la cdena del base64
      fileObtenido = fileObtenido.slice(28,-1)
      const byteArray = new Uint8Array(atob(fileObtenido).split('').map((char) => char.charCodeAt(0)));
      const file = new Blob([byteArray], {type: 'application/pdf'});
      this.datalocalURL = URL.createObjectURL(file);
      window.open(this.datalocalURL, '_blank');

    } catch (e) {
      this.popupService.errorAlert(
        'Ocurrió un error al cargar el documento.',
        4000);
      console.log("este es el error", e)
    }

  }

  getErrorMessage(field: string): string {
    let message;

    switch (field) {
      case 'actVisit':
        if (
          this.infoVisitForm?.get(field).hasError('required') &&
          this.isTouchedField(this.infoVisitForm, field)
        ) {
          message = 'Es requerido';
        } else if (
          this.infoVisitForm?.get(field).hasError('pattern') &&
          this.isTouchedField(this.infoVisitForm, field)
        ) {
          message = 'Solo se admiten números';
        }
        break;
      case 'dateVisit':
        if (
          this.infoVisitForm?.get(field).hasError('required') &&
          this.isTouchedField(this.infoVisitForm, field)
        ) {
          message = 'Es requerido';
        } else if (
          this.infoVisitForm?.get(field).hasError('invalidDate') &&
          this.isTouchedField(this.infoVisitForm, field)
        ) {
          message = 'La fecha no puede ser una fecha futura o superior a la de hoy';
        }
        break;
      case 'file':
        if (
          this.infoVisitForm?.get(field).hasError('required') &&
          this.isTouchedField(this.infoVisitForm, field)
        ) {
          message = 'Es requerido';
        }
        break;
    }

    return message;
  }

  verificarFecha() {
    //Bloquea del calendario desplegable
    const datepicker = document.getElementById('fecha-visita');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker.setAttribute('max', `${year}-${month}-${date}`);

  }

  removeFileAdded() {
    this.documentActual = null;
    (<HTMLInputElement>document.getElementById(`inputDocActaVisita`)).value = '';
  }

  extraerBase64 = async ($event: any) => new Promise((resolve, reject) => {
    try {
   

      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          base: null
        });
      };

    } catch (e) {
      return null;
    }
  })

}
